import { render, staticRenderFns } from "./AgeInputQuizDialog.vue?vue&type=template&id=4bbfeb98&scoped=true&"
import script from "./AgeInputQuizDialog.vue?vue&type=script&lang=js&"
export * from "./AgeInputQuizDialog.vue?vue&type=script&lang=js&"
import style0 from "./AgeInputQuizDialog.vue?vue&type=style&index=0&id=4bbfeb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbfeb98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCheckbox,VCol,VForm,VIcon,VRow,VSelect,VTextField})
